import "../styles/index.scss";
import hljs from "highlight.js";

hljs.initHighlightingOnLoad();

// page

const anchors = document.querySelectorAll(".anchor");

anchors.forEach((anchor, i) => {
  anchor.addEventListener("click", function (e) {
    let marker = e.target.dataset.destination;
    let dest = i === 0 ? document.body : document.getElementById(marker);
    dest.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });

    toggleActiveClass();
    anchor.classList.add("text-indigo-500");
  });
});

function toggleActiveClass() {
  anchors.forEach((anchor) => {
    anchor.classList.remove("text-indigo-500");
    anchor.classList.add("text-gray-500");
  });
}
